import { Endereco } from "./Endereco.ts";
import { Pessoa } from "./Pessoa.ts";

export class Paciente extends Pessoa {
  cpf?: string;
  ativo: boolean;

  endereco: Endereco;
  dataNascimento?: string;

  constructor(
    id = 0,
    nome = "",
    email = "",
    telefone = "",
    cpf = "",
    endereco: Endereco,
    dataNascimento = ""
  ) {
    super(id, nome, email, telefone);
    this.cpf = cpf;
    this.ativo = true;
    this.endereco = endereco || new Endereco();
    this.dataNascimento = dataNascimento || undefined;
  }
}
